import React, { useRef, useState, forwardRef } from 'react'
import { Button, Divider, Input, Select } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { createDepartment } from 'src/features/SpecialPurchasesSlice'
import styled from 'styled-components'

const CustomDepartmentSearch = forwardRef(
  ({ handleChange, setOpen, open, value }, ref) => {
    const [name, setName] = useState('')
    const [isCreating, setIsCreating] = useState(false)
    const departments = useSelector(state => state.purchases.departments)
    const venueId = useSelector(state => state.venue.venue._id)
    const dispatch = useDispatch()

    const inputRef = useRef(null)

    const onNameChange = event => {
      setName(event.target.value)
    }

    const addItem = async e => {
      e.preventDefault()
      e.stopPropagation()

      if (!name.trim()) {
        console.log('No department name provided')
        return
      }

      if (!venueId) {
        console.log('No venue ID available')
        return
      }

      if (isCreating) {
        console.log('Already creating department, please wait')
        return
      }

      console.log('Creating department:', name.trim(), 'for venue:', venueId)
      setIsCreating(true)

      try {
        // Keep dropdown open during creation
        const newDepartment = await dispatch(
          createDepartment(venueId, name.trim()),
        ).unwrap()
        console.log('Department created successfully:', newDepartment)
        handleChange('department', newDepartment._id)
        setName('')
        // Close dropdown only after successful creation
        setOpen(false)
      } catch (error) {
        console.error('Failed to create department:', error)
        // Keep dropdown open if creation fails so user can try again
      } finally {
        setIsCreating(false)
      }
    }

    return (
      <Wrapper ref={ref} style={{ width: '100%' }}>
        <Select
          open={open}
          onDropdownVisibleChange={visible => {
            if (visible) setOpen(true)
          }}
          className='bdr-none'
          placeholder='Department'
          style={{
            width: '100%',
            border: 'transparent !important',
          }}
          dropdownStyle={{
            border: 'none',
            boxShadow: 'none',
          }}
          value={value}
          onSelect={() => setOpen(false)}
          onChange={value => {
            handleChange('department', value)
          }}
          dropdownRender={menu => (
            <div onClick={e => e.stopPropagation()}>
              {menu}
              <Divider style={{ margin: '8px 0' }} />
              <div
                style={{
                  padding: '0 8px 4px',
                  display: 'flex',
                  gap: '8px',
                }}
              >
                <Input
                  placeholder='Please enter department'
                  ref={inputRef}
                  value={name}
                  onChange={onNameChange}
                  disabled={isCreating}
                  onKeyDown={e => {
                    e.stopPropagation()
                    if (e.key === 'Enter' && !isCreating && name.trim()) {
                      e.preventDefault()
                      addItem(e)
                    }
                  }}
                  style={{ flex: 1 }}
                />
                <Button
                  type='link'
                  icon='plus'
                  onClick={addItem}
                  loading={isCreating}
                  disabled={isCreating || !name.trim()}
                >
                  Add Department
                </Button>
              </div>
            </div>
          )}
        >
          {departments && departments.length > 0 ? (
            departments.map((department, index) => (
              <Select.Option
                key={`${department._id}-${index}`}
                value={department._id}
              >
                {department.name}
              </Select.Option>
            ))
          ) : (
            <Select.Option disabled value='no-departments'>
              No departments available
            </Select.Option>
          )}
        </Select>
      </Wrapper>
    )
  },
)

const Wrapper = styled.div``

export default CustomDepartmentSearch
